class Search {
    constructor() {
        console.log('Search constructor');
        setTimeout(() => {
            // Ocultar pagina resultados
            const buscador = document.querySelector('.search-results-header input[type="search"]');
            if (buscador) {
                console.log('buscador', buscador);
                const buscadorLiveResults = document.querySelector('#' + buscador.getAttribute('aria-owns'));
                buscadorLiveResults.style.display = 'none';
            }

            // Marcar resultados mobile como mobile
            const buscadorMobile = document.querySelector('.buscador-movil input[type="search"]');
            if (buscadorMobile) {
                console.log('buscadorMobile', buscadorMobile);
                const buscadorMobileLiveResults = document.querySelector('#' + buscadorMobile.getAttribute('aria-owns'));
                buscadorMobileLiveResults.classList.add('buscador-movil-live-results');
            }

            // Marcar resultados desktop como desktop
            const buscadorDesktop = document.querySelector('.buscador input[type="search"]');
            if (buscadorDesktop) {
                console.log('buscadorDesktop', buscadorDesktop);
                const buscadorDesktopLiveResults = document.querySelector('#' + buscadorDesktop.getAttribute('aria-owns'));
                buscadorDesktopLiveResults.classList.add('buscador-desktop-live-results');
            }
        }, 500);
    }
}

export default Search;